import React from 'react';
import { NavLink } from 'react-router-dom'

const mainMenu = [
  {
    "name": "Мониторинг",
    "key": "menu_mon",
    "icon": "icon-eye",
    "submenu": [
      {
        "name": "Связь КНАП",
        "key": "menu_knapdata",
        "icon": "icon-cursor",
        "action": "/knapdata"
      }
    ]
  },
  {
    "name": "Сервисы",
    "key": "menu_ser",
    "icon": "icon-organization",
    "submenu": [
      {
        "name": "ГЛОНАСС-ЭРА",
        "key": "menu_control",
        "icon": "icon-globe",
        "action": "/module_glonass_era_egts"
      },
      {
        "name": "АПК Консул",
        "key": "menu_admin",
        "icon": "icon-feed",
        "action": "/apkkonsul"
      },
      {
        "name": "РРР",
        "key": "menu_PPP",
        "icon": "icon-organization",
        "action": "/ppp"
      },
      {
        "name": "Внешние системы",
        "key": "menu_sys",
        "icon": "icon-organization",
        "action": "/outsystem"
      }
    ]
  },
  {
    "name": "Журнал",
    "key": "spr_protocols",
    "icon": "icon-folder-alt",
    "submenu": [
      {
        "name": "Данные НАП",
        "key": "menu_napdata",
        "icon": "icon-location-pin",
        "action": "/napdata"
      },
      {
        "name": "Данные МС",
        "key": "menu_datams",
        "icon": "icon-map",
        "action": "/msdata",
        "rules": "spr"
      },
      {
        "name": "Данные ККС",
        "key": "menu_kkcdata",
        "icon": "icon-doc",
        "action": "/kkcdata",
        "rules": "spr"
      }
    ]
  },
]

const MenuItems = (props) => {
  if (props.items === null) return null;
  console.log(props.items);
  let v_ret = props.items.map(function (item, index) {
    if ("submenu" in item)
      return (
        <li key={item.key} className="dropdown"><a href="#"><i className={"me-2 " + item.icon}></i>{item.name}</a>
          <ul>
            <MenuItems items={item.submenu} />

          </ul>
        </li>
      );
    else
      return (
        <li key={item.key}><NavLink to={item.action}><i className={"me-2 " + item.icon}></i>{item.name}</NavLink></li>
      );
  });
  return v_ret;
}

const Menu = (props) => {
  console.log(props.menu);
  return (
    <div className="sidebar pt-0" data-bs-theme={(props.settings.themeColor ?? "light") === "light" ? "light" : "dark"}>
      <div className="site-width">
        <ul id="side-menu" className="sidebar-menu">
          {/* <MenuItems items={props.menu} /> */}
          <MenuItems items={mainMenu} />
        </ul>
      </div>
    </div>
  );
}

export default React.memo(Menu);
